export default __webpack_public_path__ + "static/media/male.22c31152.png";